import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
export const hasReachedEndOfPage = () => {
  if (typeof document === 'undefined') return false;
  return document.body.scrollHeight - document.documentElement.scrollTop <= window.innerHeight;
};
const hasReachedTopOfPage = () => {
  if (typeof document === 'undefined') return true;
  return document.documentElement.scrollTop === 0;
};
export const ANIMATION_DURATION = 500;
export interface UseScrollAnimationArgs {
  toggleVisibilityCallback: (shouldTrigger: boolean) => void;
  hideAtTopOfPage?: boolean;
  showAtEndOfPage?: boolean;
  initialOffset?: string;
}
const useScrollAnimation = t0 => {
  const $ = _c(8);
  const {
    toggleVisibilityCallback,
    hideAtTopOfPage: t1,
    showAtEndOfPage: t2,
    initialOffset: t3
  } = t0;
  const hideAtTopOfPage = t1 === undefined ? false : t1;
  const showAtEndOfPage = t2 === undefined ? false : t2;
  const initialOffset = t3 === undefined ? "0px" : t3;
  const [offset, setOffset] = useState(initialOffset);
  const isReducedMotionEnabled = useMediaQuery("(prefers-reduced-motion: reduce)");
  let t4;
  let t5;
  if ($[0] !== hideAtTopOfPage || $[1] !== isReducedMotionEnabled || $[2] !== showAtEndOfPage || $[3] !== toggleVisibilityCallback) {
    t4 = () => {
      if (isReducedMotionEnabled) {
        return;
      }
      let lastScrollY = window.scrollY;
      let isTicking = false;
      const update = () => {
        const scrollY = window.scrollY;
        if (scrollY < lastScrollY) {
          toggleVisibilityCallback(hideAtTopOfPage ? !hasReachedTopOfPage() : true);
        } else {
          toggleVisibilityCallback(showAtEndOfPage ? hasReachedEndOfPage() : false);
        }
        lastScrollY = scrollY;
        isTicking = false;
      };
      const onScroll = () => {
        if (!isTicking) {
          window.requestAnimationFrame(update);
          isTicking = true;
        }
      };
      window.addEventListener("scroll", onScroll);
      return () => {
        window.removeEventListener("scroll", onScroll);
      };
    };
    t5 = [hideAtTopOfPage, showAtEndOfPage, toggleVisibilityCallback, isReducedMotionEnabled];
    $[0] = hideAtTopOfPage;
    $[1] = isReducedMotionEnabled;
    $[2] = showAtEndOfPage;
    $[3] = toggleVisibilityCallback;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== offset) {
    t6 = [offset, setOffset];
    $[6] = offset;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6 as const;
};
export default useScrollAnimation;